import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import { CircularProgress, Box } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Lazy load page components for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Programs = lazy(() => import('./pages/Programs'));
const Membership = lazy(() => import('./pages/Membership'));
const Leadership = lazy(() => import('./pages/Leadership'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A4D2E',
    },
    secondary: {
      main: '#C4A484',
    },
    background: {
      default: '#F8F6F1',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Inter", sans-serif',
  },
});

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col">
          {/* Skip to main content link for keyboard navigation */}
          <a 
            href="#main-content" 
            className="skip-to-content"
            style={{
              position: 'absolute',
              left: '-9999px',
              zIndex: 999,
              padding: '1rem',
              backgroundColor: '#1A4D2E',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '0 0 4px 0',
            }}
            onFocus={(e) => e.target.style.left = '0'}
            onBlur={(e) => e.target.style.left = '-9999px'}
          >
            Skip to main content
          </a>
          <Navbar />
          {/* Spacer for fixed navbar */}
          <div style={{ height: '60px' }}></div>
          <main id="main-content" className="flex-grow" tabIndex={-1}>
            <Suspense fallback={
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <CircularProgress sx={{ color: '#1A4D2E' }} size={60} />
              </Box>
            }>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/programs" element={<Programs />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/leadership" element={<Leadership />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
